import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetConfigPedidoVendaResponse } from '../../responses/vendas/get-config-pedido-venda.response';
import { ConfigPedidoVendaLookupsResponse } from '../../responses/vendas/config-pedido-venda-lookups.response';
import { ConfigPedidoVendaRequest } from '../../requests/vendas/config-pedido-venda.request';

@Injectable({
    providedIn: 'root',
})
export class ConfigPedidoVendaService extends CommonService {
    private readonly apiUrl: string = environment.urlApiVendas + 'ConfigPedidoVenda';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(): Observable<GetConfigPedidoVendaResponse> {
        return this.httpClient
            .get<GetConfigPedidoVendaResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookups(): Observable<ConfigPedidoVendaLookupsResponse> {
        return this.httpClient
            .get<ConfigPedidoVendaLookupsResponse>(`${this.apiUrl}/lookups`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: ConfigPedidoVendaRequest): Observable<GetConfigPedidoVendaResponse> {
        const url = `${this.apiUrl}/idConfigPedidoVenda/${id}`;
        return this.httpClient
            .put<GetConfigPedidoVendaResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
